import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Container } from "react-bootstrap";
import { LuMoveLeft, LuMoveRight } from "../../../../assets/logos/index";
import useSocialLinkss from "../../../hooks/useSocialLinkss";

const SocialLinks = () => {
  const swiperRef = useRef(null);
  const { data, isLoading, isError, status } = useSocialLinkss();
  if (isLoading) return <div className="spinner"></div>;
  if (status === "failed") return <div>Error: {isError}</div>;
  console.log("datadatadatadata", data);
  function getFacebookEmbedUrl(postUrl) {
    return `https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(
      postUrl
    )}&show_text=true&width=500`;
  }

  const socialLinks = data?.allMediaLinks;
  const handlePrevClick = () => {
    swiperRef.current.swiper.slidePrev();
  };

  const handleNextClick = () => {
    swiperRef.current.swiper.slideNext();
  };

  return (
    <div>
      <Container className="py-lg-4 py-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h2 className="top-programmes-title photo-gallery-title align-items-center heading-font">
              Latest Feed
            </h2>
          </div>
          <span>
            <button
              className="btn px-3 py-0 fs-2 border-0"
              onClick={handlePrevClick}
              aria-label="handlePrevClick"
            >
              <LuMoveLeft />
            </button>
            <button
              className="btn px-3 py-0 fs-2 border-0"
              onClick={handleNextClick}
              aria-label="handleNextClick"
            >
              <LuMoveRight />
            </button>
          </span>
        </div>

        <Swiper
          ref={swiperRef}
          spaceBetween={10}
          modules={[]}
          className="mySwiper "
          breakpoints={{
            400: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
        >
          {socialLinks &&
            socialLinks.length > 0 &&
            socialLinks?.map((social, index) => (
              <SwiperSlide key={index} className="photo-gallery-slider-card">
                <div className="mb-4">
                  <p
                    className="fw-bold mb-2  line-clamp-2"
                    title={social.title}
                  >
                    {social.title}
                  </p>

                  <div style={{ maxWidth: "100%", margin: "0 auto" }}>
                    <iframe
                      src={getFacebookEmbedUrl(social.media)}
                      title={social.title}
                      style={{
                        height: "600px",
                        width:"100%"
                      }}
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </Container>
    </div>
  );
};

export default SocialLinks;
